<script setup>
import { computed, ref, toRefs } from 'vue';
import useVuelidate from '@vuelidate/core';
import { helpers } from '@vuelidate/validators';
import { isEmpty } from '@/common/utils/Util';
import router from '@/router';
import { showTextModal } from '@/common/utils/ModalState';
import store from '@/store';
import ServiceExec from '@/common/utils/ServiceExec';
const props = defineProps(['data']);
const { url } = toRefs(props.data);
let inputPassword = ref('');
const emits = defineEmits(['close']);

const user = computed(() => store.getters['user/getUserData']);

const valid = {
  inputPassword: {
    isEmpty: helpers.withMessage('웰다잉 비밀번호를 입력해 주세요.', value => {
      return !isEmpty(value);
    })
  }
};
const v$ = useVuelidate(valid, {
  inputPassword
});

const fnConfirm = async () => {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  // 260628: wellPassword는 bcrypt 단방향 해시(260521 전환)라 클라 평문 비교 불가 → 서버 검증(passwordEncoder.matches).
  const { status, data } = await ServiceExec.post('/api/user/verify/well-password', {
    userNo: user.value.userNo,
    wellPassword: inputPassword.value
  });
  if (status !== ServiceExec.status.OK || !data) {
    showTextModal('비밀번호가 일치하지 않습니다.', '확인');
    return;
  }
  emits('close');
  if (url?.value) {
    router.replace(url.value);
  } else {
    router.push('/welldying/menu');
  }
};

const fnReset = () => {
  emits('close');
  router.push('/setting/welldying/password');
};

const fnClose = () => {
  if (url?.value) {
    router.replace({ path: '/main', query: { isRoot: 1 } });
  } else {
    emits('close');
  }
};
</script>

<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-head">
            <button class="header-btn" @click="fnClose"><i class="ico-close-gray90"></i></button>
          </div>
          <div class="modal-con">
            <div class="modal-txt">
              <div class="form">
                <ul class="form-ul">
                  <li class="form-li">
                    <div class="form-ttl essen">
                      <!--필수값: essen-->
                      <span>웰다잉 비밀번호 입력</span>
                    </div>
                    <div class="form-in">
                      <label class="label">
                        <input
                          type="password"
                          inputmode="numeric"
                          v-model="inputPassword"
                          maxlength="6"
                          placeholder="비밀번호 숫자 6자리를 입력해 주세요."
                        />
                      </label>
                    </div>
                    <div class="valid" :class="v$.inputPassword.$error ? 'on' : ''">
                      {{ v$.inputPassword.isEmpty.$message }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn medium border-gray" @click="fnReset">비밀번호 재설정</button>
              <button class="btn primary medium" @click="fnConfirm()">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
